import React, { useState } from "react"

import ProductMediaInPageSwiper from "./ProductMediaInPageSwiper"
import ProductMediaModalSwiper from "./ProductMediaModalSwiper"
import { Dialog, Transition } from "@headlessui/react"
import { Close16 } from "@carbon/icons-react"

const ProductMediaGallery = ({ variant }) => {
  const [showMediaSwiperModal, setShowMediaSwiperModal] = useState(false)
  const [startMediaModalSwipeIndex, setStartMediaModalSwipeIndex] = useState(0)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const openModalHandler = (modalMode, slideIdx = 0) => {
    if (modalMode === "media-swiper") {
      setStartMediaModalSwipeIndex(slideIdx)
      setShowMediaSwiperModal(true)
      setIsModalOpen(true)
    }
  }
  const closeModalHandler = () => {
    setStartMediaModalSwipeIndex(0)
    setShowMediaSwiperModal(false)
    setIsModalOpen(false)
  }

  let relevantVideos = []

  if (variant.productVideos?.items && variant.productVideos?.items.length > 0) {
    relevantVideos = variant.productVideos?.items.map((i) => {
      return { originId: variant.productVideos?.originId, ...i }
    })
  }

  let relevantImages = []
  if (variant.productImages?.items?.length > 0) {
    relevantImages.push(
      variant.productImages?.items.map((i) => {
        return { originId: variant.productImages?.originId, ...i }
      })
    )
  }
  if (variant.applicationImages?.items?.length > 0) {
    relevantImages.push(
      variant.applicationImages?.items.map((i) => {
        return { originId: variant.applicationImages?.originId, ...i }
      })
    )
  }
  if (variant.detailImages?.items?.length > 0) {
    relevantImages.push(
      variant.detailImages?.items.map((i) => {
        return { originId: variant.detailImages?.originId, ...i }
      })
    )
  }
  if (variant.marketingImages?.items?.length > 0) {
    relevantImages.push(
      variant.marketingImages?.items.map((i) => {
        return { originId: variant.marketingImages?.originId, ...i }
      })
    )
  }
  if (variant.packagingImages?.items?.length > 0) {
    relevantImages.push(
      variant.packagingImages?.items.map((i) => {
        return { originId: variant.packagingImages?.originId, ...i }
      })
    )
  }
  if (variant.miscImages?.items?.length > 0) {
    relevantImages.push(
      variant.miscImages?.items.map((i) => {
        return { originId: variant.miscImages?.originId, ...i }
      })
    )
  }
  relevantImages = relevantImages.flat()
  let galleryObjects = relevantImages.map((item) => {
    if (item.value === "undefined") {
      return { type: "noimage", url: process.env.GATSBY_IMG_PLACEHOLDER }
    } else {
      return { type: "image", url: item.value, originId: item.originId }
    }
  })

  // append video(s) if it fits in the total 4 items limit
  if (galleryObjects.length + relevantVideos.length <= 4) {
    galleryObjects.push(
      ...relevantVideos.map((item) => {
        return { type: "video", url: item.label, originId: item.originId }
      })
    )
  } else {
    // otherwise insert the videos
    relevantVideos.forEach((item) => {
      galleryObjects.splice(4 - relevantVideos.length, 0, {
        type: "video",
        url: item.label,
        originId: item.originId,
      })
    })
  }

  return (
    <div>
      <ProductMediaInPageSwiper
        triggerSlideClick={true}
        onSlideClickCallback={(slideIdx) =>
          openModalHandler("media-swiper", slideIdx)
        }
        mediaItems={galleryObjects}
      />

      <Transition appear show={isModalOpen} as={React.Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-[1000] overflow-y-auto"
          onClose={() => closeModalHandler()}
        >
          {showMediaSwiperModal && (
            <div className="fixed inset-x-0 top-0 bottom-0 flex">
              <div className="relative w-full h-screen bg-white">
                <button
                  className="absolute top-0 right-0 z-20 w-12 h-12 bg-white hover:bg-gray-100 active:bg-gray-200"
                  onClick={() => closeModalHandler()}
                >
                  <Close16 className="w-12 h-12 p-2" />
                </button>
                <div className="self-center w-full">
                  <div className="relative h-screen bg-white">
                    <ProductMediaModalSwiper
                      mediaItems={galleryObjects}
                      startIdx={startMediaModalSwipeIndex}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </Dialog>
      </Transition>
    </div>
  )
}

export default ProductMediaGallery
